$(document).ready(function(){
  // customize product form
  $(".CustomizeImageForm").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.CustomizeImageForm').prop('files')[0];
      var imageName = $('.CustomizeImageForm').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.CustomizeImageForm').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/customize-product/images/"+ne_get_1;
      var formData = new FormData($("#Customizecustom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/customize-product/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#Customizecustom_form #Customizebar").show();
              $("#Customizecustom_form #Customizebar").text("("+percentComplete+"%)");
              $("#Customizecustom_form .Customizebar_wrapper_1").show();
              $("#Customizecustom_form .CustomizeimageWrapp").css("display","none");
              $("#Customizecustom_form .Customizemsg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("Customizebar").style.width=percentComplete+'%';
              document.getElementById("Customizebar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#Customizecustom_form .CustomizeimageWrapp").css("display","none");
                $("#Customizecustom_form .Customizemsg_uploading_1").html(imageName+" Image Uploaded");
                $("#Customizecustom_form .Customizebar_wrapper_1.Customizeprogress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#Customizecustom_form .CustomizeImageForm").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      });
    }
  });

  /****************FORM SUBMIT *********************/
  function setCookie2(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie2(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  var OrderId2 = getCookie2("OrderId");

  $(".CustomizebtnGtsrtd button.form-btn.btn.btn-default").click(function(){

    var productGet = $(".product_link").val();
    var nameGet = $(".CustomizeNameForm").val();
    var emailGet = $(".CustomizeEmailForm").val();
    var ImageGet = $(".CustomizeImageForm").attr("data-src");
    var DescriptionGet = $(".CustomizeDescriptionForm").val();

    validateEmail(emailGet);

    function validateEmail(email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailReg.test(email)) {
        $("input.form-control.CustomizeEmailForm").css("border","1px solid red");
      }
      else if((emailGet=='')&&(nameGet=='')){
        $("input.form-control.CustomizeEmailForm").css("border","1px solid red");
        $("input.form-control.CustomizeNameForm").css("border","1px solid red");
      }
      else if((emailGet=='')||(nameGet=='')){

        if(emailGet==''){
          $("input.form-control.CustomizeEmailForm").css("border","1px solid red");
        }
        else{
          $("input.form-control.CustomizeNameForm").css("border","1px solid red");
        }
      }

      else {

        $(".CentreWrap button.form-btn.btn.btn-default").addClass("LoaderForm");
        var OrderId2 = Math.floor((Math.random() * 10000000) + 1);
        setCookie2("OrderId", OrderId2, 365);
        $.ajax({
          type: 'POST',
          url: 'https://deluxeplumbers.com/leathershopify/postmarkapp/src/customize-product.php',
          data: {ImageGet:(ImageGet),name:(nameGet),email:(emailGet),description:(DescriptionGet),productGet:(productGet) },
          dataType: 'html',
          success: function(response){
            
             window.location.href = "/pages/thank-you" ;
            var OrderId2 = getCookie2("OrderId");
            $(".hdrbg h3 b").html(OrderId);
//             $(".ordernum_customize").html(OrderId2);
//             $('.customizeProductForm').hide();
//             $('.customizethankyou').show();
          }
        })
      }
    }

  });

  // ask a question form
  $(".askQuestionImageForm").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.askQuestionImageForm').prop('files')[0];
      var imageName = $('.askQuestionImageForm').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.askQuestionImageForm').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/ask-question/images/"+ne_get_1;
      var formData = new FormData($("#askQuestioncustom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/ask-question/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#askQuestioncustom_form #askQuestionbar").show();
              $("#askQuestioncustom_form #askQuestionbar").text("("+percentComplete+"%)");
              $("#askQuestioncustom_form .askQuestionbar_wrapper_1").show();
              $("#askQuestioncustom_form .askQuestionimageWrapp").css("display","none");
              $("#askQuestioncustom_form .askQuestionmsg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("askQuestionbar").style.width=percentComplete+'%';
              document.getElementById("askQuestionbar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#askQuestioncustom_form .askQuestionimageWrapp").css("display","none");
                $("#askQuestioncustom_form .askQuestionmsg_uploading_1").html(imageName+" Image Uploaded");
                $("#askQuestioncustom_form .askQuestionbar_wrapper_1.askQuestionprogress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#askQuestioncustom_form .askQuestionImageForm").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
        }
      });
    }
  });


  /****************FORM SUBMIT *********************/
  function setCookie1(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie1(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  var OrderId1 = getCookie1("OrderId");

  $(".askQuestionbtnGtsrtd button.form-btn.btn.btn-default").click(function(){

    var productGet = $(".product_link_question").val();
    var nameGet = $(".askQuestionNameForm").val();
    var emailGet = $(".askQuestionEmailForm").val();
    var ImageGet = $(".askQuestionImageForm").attr("data-src");
    var DescriptionGet = $(".askQuestionDescriptionForm").val();

    validateEmail(emailGet);

    function validateEmail(email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailReg.test(email)) {
        $("input.form-control.askQuestionEmailForm").css("border","1px solid red");
      }
      else if((emailGet=='')&&(nameGet=='')){
        $("input.form-control.askQuestionEmailForm").css("border","1px solid red");
        $("input.form-control.askQuestionNameForm").css("border","1px solid red");
      }
      else if((emailGet=='')||(nameGet=='')){

        if(emailGet==''){
          $("input.form-control.askQuestionEmailForm").css("border","1px solid red");
        }
        else{
          $("input.form-control.askQuestionNameForm").css("border","1px solid red");
        }
      }

      else {

        $(".CentreWrap button.form-btn.btn.btn-default").addClass("LoaderForm");
        var OrderId1 = Math.floor((Math.random() * 10000000) + 1);
        setCookie1("OrderId", OrderId1, 365);
        $.ajax({
          type: 'POST',
          url: 'https://deluxeplumbers.com/leathershopify/postmarkapp/src/ask-question.php',
          data: {ImageGet:(ImageGet),name:(nameGet),email:(emailGet),description:(DescriptionGet),productGet:(productGet) },
          dataType: 'html',
          success: function(response){
            var OrderId1 = getCookie1("OrderId");
//             $(".ordernum").html(OrderId1);
//             $('.askQuestionForm').hide();
//             $('.askQuestionthankyou').show();
            window.location.href = "/pages/thank-you" ;
            $(".hdrbg h3 b").html(OrderId1);
          }
        })
      }
    }

  });





});